import { render, staticRenderFns } from "./ImgDocumentBlock.vue?vue&type=template&id=69d86d1c"
import script from "./ImgDocumentBlock.vue?vue&type=script&lang=js"
export * from "./ImgDocumentBlock.vue?vue&type=script&lang=js"
import style0 from "./ImgDocumentBlock.vue?vue&type=style&index=0&id=69d86d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports